import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

function MoveExecutionBtn({ handler, movePositionTo }) {
  const [open, setOpen] = useState(false);

  function handleClose() {
    setOpen(false);
  }

  return (
    <>
      <Button
        variant='outlined'
        size='small'
        //sx={{ fontSize: '9px' }}
        onClick={() => {
          setOpen(true);
        }}
        disabled={movePositionTo ? false : true}
      >
        Оформить перемещение
      </Button>
      <Dialog open={open} onClose={handleClose} aria-labelledby='alert-dialog-title' aria-describedby='alert-dialog-description'>
        <DialogTitle id='alert-dialog-title'>{'Оформление перемещения выделенных строк'}</DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>Вы уверены ?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Нет</Button>
          <Button
            onClick={() => {
              handler();
              handleClose();
            }}
            autoFocus
          >
            Да
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default MoveExecutionBtn;
